import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { AuthContainer } from "../../styles/LoginSignUp/authContainer";
import api from '../../services/api';
import { Spin } from 'antd';
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";

export const Authorization: React.FC = () => {
  const { token } = useParams();
  const { user } = useAuth();
  const [isSucess, setIsSucess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api.post(`/auth/client/${token}`, {}).then(() => {
      setIsSucess(true);
    })
      .catch(() => setIsSucess(false))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <AuthContainer className="beauty-scrollbar">
      <div className="auth-content">
        {loading ? (
          <Spin />
        ) :
          isSucess ? <h1>Permissão Concedida.</h1> : <h1>Houve algum erro.</h1>
        }
        {
          user?.user
            ?
            <Button
              size="large"
              type="primary"
              onClick={() => navigate("/clients")}
            >
              Voltar para o APP
            </Button>
            :
            null
        }
      </div>
    </AuthContainer>
  );
};
